<nb-card class="buy-credits-dialog" [nbSpinner]="submitting" nbSpinnerStatus="primary">
  <nb-card-header>
    <div>
      <h4>{{ 'pages.organisation.credits.buyDialog.title' | translate }}</h4>
    </div>
    <button nbButton ghost status="basic" size="small" type="button" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="form" (ngSubmit)="buy()">
      <p class="hint">
        {{ 'pages.organisation.credits.buyDialog.hint' | translate: { min: minEur } }}
      </p>

      <div class="quick-picks">
        <button
          *ngFor="let amount of quickPicks"
          type="button"
          nbButton
          size="small"
          [status]="eurValue === amount ? 'primary' : 'basic'"
          (click)="pick(amount)"
        >
          {{ amount }} €
        </button>
      </div>

      <div class="field-row">
        <label for="eur_amount">{{ 'pages.organisation.credits.buyDialog.amount' | translate }}</label>
        <nb-form-field>
          <input
            id="eur_amount"
            nbInput
            fullWidth
            type="number"
            [min]="minEur"
            [max]="maxEur"
            step="1"
            formControlName="eur_amount"
          />
          <span nbSuffix>€</span>
        </nb-form-field>
      </div>

      <p class="error" *ngIf="form.controls.eur_amount.invalid && form.controls.eur_amount.touched">
        {{ 'pages.organisation.credits.buyDialog.invalid' | translate: { min: minEur, max: maxEur } }}
      </p>

      <section class="tile-flat preview" *ngIf="form.controls.eur_amount.valid">
        <header class="tile-flat__header">
          <h5>{{ 'pages.organisation.credits.buyDialog.preview' | translate }}</h5>
        </header>
        <div class="preview-grid">
          <div>
            <span class="preview-label">{{ 'pages.organisation.credits.credits' | translate }}</span>
            <strong>{{ previewCredits | number }}</strong>
          </div>
        </div>
        <p class="preview-note">
          {{ 'pages.organisation.credits.buyDialog.vatNote' | translate }}
        </p>
        <p class="preview-note">
          {{ 'pages.organisation.credits.buyDialog.validity' | translate }}
        </p>
      </section>
    </form>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="basic" type="button" (click)="close()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button
      nbButton
      status="primary"
      type="button"
      [disabled]="form.invalid || submitting"
      (click)="buy()"
    >
      {{ 'pages.organisation.credits.buyDialog.submit' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
